import React from 'react';
import { Link } from 'react-router-dom';
import { contactInfo } from '../mock';
import { MapPin, Phone, Instagram, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'Collections', href: '/#collections' },
    { name: 'About', href: '/#about' },
    { name: 'Gallery', href: '/#gallery' },
    { name: 'Contact', href: '/#contact' },
    { name: 'Privacy Policy', href: '/privacy-policy' }
  ];

  const categories = [
    "Men's Footwear",
    "Women's Footwear",
    "Kids' Footwear",
    "Formal Collection",
    "Casual Wear",
    "Sports Collection",
    "Traditional & Ethnic"
  ];

  return (
    <footer className="bg-[#1e1919] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold tracking-tight">
              <span className="text-[#dc143c]">BHARGAVA'S</span>{' '}
              <span className="text-white">SHOES</span>
            </h3>
            <p className="text-xs text-[#bbb5ae] tracking-wider">SINCE 1911</p>
            <p className="text-sm text-[#bbb5ae] leading-relaxed">
              Your trusted destination for premium footwear in Bathinda. Offering quality, style, and comfort for over a decade.
            </p>
            <div className="flex items-center gap-4">
              <a
                href={contactInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gradient-to-br from-purple-600 to-pink-600 rounded-sm flex items-center justify-center hover:from-purple-700 hover:to-pink-700 transition-all duration-300"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          <div className="space-y-6">
            <h4 className="text-lg font-bold text-white tracking-tight uppercase">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-sm text-[#bbb5ae] hover:text-white transition-colors duration-300"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-6">
            <h4 className="text-lg font-bold text-white tracking-tight uppercase">
              Collections
            </h4>
            <ul className="space-y-3">
              {categories.slice(0, 5).map((category, index) => (
                <li key={index}>
                  <a
                    href="/#collections"
                    className="text-sm text-[#bbb5ae] hover:text-white transition-colors duration-300"
                  >
                    {category}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-6">
            <h4 className="text-lg font-bold text-white tracking-tight uppercase">
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#bbb5ae] flex-shrink-0 mt-1" />
                <span className="text-sm text-[#bbb5ae] leading-relaxed">
                  {contactInfo.address}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-[#bbb5ae] flex-shrink-0" />
                <a
                  href={`tel:${contactInfo.phone}`}
                  className="text-sm text-[#bbb5ae] hover:text-white transition-colors duration-300"
                >
                  {contactInfo.phone}
                </a>
              </li>
            </ul>
            <div className="pt-4">
              <p className="text-xs text-[#bbb5ae] uppercase tracking-wider mb-2">Business Hours</p>
              <p className="text-sm text-[#bbb5ae]">Weekdays: {contactInfo.hours.weekdays}</p>
              <p className="text-sm text-[#bbb5ae]">Weekends: {contactInfo.hours.weekends}</p>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#736c64]/30">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <p className="text-sm text-[#bbb5ae]">
                © {currentYear} Bhargava Shoes. All rights reserved.
              </p>
              <Link to="/privacy-policy" className="text-sm text-[#bbb5ae] hover:text-white transition-colors">
                Privacy Policy
              </Link>
            </div>
            <p className="text-sm text-[#bbb5ae] flex items-center gap-2">
              Made with <Heart size={16} className="text-red-500 fill-red-500" /> in Bathinda
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
